import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    surface: {
      primary: '#FFFFFF',
      secondary: '#F5F6F8',
      tertiary: '#FFFFFF',
      grouped: '#F2F3F7',
      overlay: 'rgba(255, 255, 255, 0.72)',
    },
    label: {
      primary: 'rgba(15, 23, 42, 0.88)',
      secondary: 'rgba(15, 23, 42, 0.60)',
      tertiary: 'rgba(15, 23, 42, 0.42)',
      quaternary: 'rgba(15, 23, 42, 0.24)',
    },
    accent: {
      blue: '#0A84FF',
      blueSubtle: '#E8F2FF',
      blueBorder: '#B8DAFF',
    },
    status: {
      draft: '#64748B',
      ready: '#0EA5E9',
      published: '#10B981',
      paused: '#F59E0B',
      archived: '#71717A',
      error: '#E11D48',
    },
    domain: {
      airports: '#2563EB',
      hospitality: '#7C3AED',
      foodBeverage: '#EA580C',
      retail: '#059669',
      membership: '#0F766E',
      concierge: '#C026D3',
      aviation: '#0284C7',
      destination: '#9333EA',
      tourism: '#16A34A',
    },
    brand: {
      50: '#E6F3FF',
      100: '#B3D9FF',
      200: '#80BFFF',
      300: '#4DA5FF',
      400: '#1A8BFF',
      500: '#0072E5',
      600: '#005BB3',
      700: '#004480',
      800: '#002D4D',
      900: '#00161A',
    },
    horizon: {
      50: '#F0F4F8',
      100: '#D9E2EC',
      200: '#BCCCDC',
      300: '#9FB3C8',
      400: '#829AB1',
      500: '#627D98',
      600: '#486581',
      700: '#334E68',
      800: '#243B53',
      900: '#102A43',
    },
  },
  fonts: {
    heading: 'Inter, -apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", Arial, sans-serif',
    body: 'Inter, -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
  },
  radii: {
    xs: '6px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
  },
  shadows: {
    primeSm: '0 1px 2px rgba(15,23,42,.06), 0 1px 3px rgba(15,23,42,.04)',
    primeMd: '0 4px 12px rgba(15,23,42,.08), 0 1px 4px rgba(15,23,42,.05)',
    primeLg: '0 8px 30px rgba(15,23,42,.12), 0 2px 8px rgba(15,23,42,.06)',
  },
  styles: {
    global: {
      'html, body, #root': {
        minHeight: '100%',
      },
      body: {
        bg: 'surface.secondary',
        color: 'label.primary',
        WebkitFontSmoothing: 'antialiased',
        textRendering: 'optimizeLegibility',
      },
      'button, [role="button"]': {
        minHeight: '40px',
      },
      '.tabular-nums': {
        fontVariantNumeric: 'tabular-nums',
      },
      '@media (prefers-reduced-motion: reduce)': {
        '*, *::before, *::after': {
          animationDuration: '0.01ms !important',
          animationIterationCount: '1 !important',
          transitionDuration: '0.01ms !important',
          scrollBehavior: 'auto !important',
        },
        'button, [role="button"]': {
          transform: 'none !important',
        },
      },
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'brand',
      },
      baseStyle: {
        fontWeight: '600',
        borderRadius: 'sm',
        transitionProperty: 'background-color, border-color, color, box-shadow, transform',
        transitionDuration: '150ms',
        _active: {
          transform: 'scale(0.96)',
        },
        _focusVisible: {
          boxShadow: '0 0 0 3px rgba(10, 132, 255, 0.28)',
        },
      },
    },
    Input: {
      defaultProps: {
        focusBorderColor: 'brand.500',
      },
      baseStyle: {
        field: {
          borderRadius: 'sm',
          _focusVisible: {
            boxShadow: '0 0 0 3px rgba(10, 132, 255, 0.22)',
          },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: 'md',
          boxShadow: 'primeSm',
        },
      },
    },
  },
});

export default theme;

